import React from 'react';
import { useLogin, useTranslate } from '@pankod/refine-core';
import {
  Row,
  Col,
  Card,
  Typography,
  Form,
  Input,
  Switch,
  Button,
  Divider,
} from '@pankod/refine-antd';

import { GoogleOutlined, FacebookOutlined } from '@ant-design/icons';

import './login.css';

const { Title, Text } = Typography;

interface LoginForm {
  username?: string;
  password: string;
  remember: boolean;
  email?: string;
  phone?: string;
}

export const Login: React.FC = () => {
  const [form] = Form.useForm<LoginForm>();
  const [usePhone, setUsePhone] = React.useState(false);
  const t = useTranslate();
  const { mutate: signIn } = useLogin<LoginForm>();

  const handleSubmit = (values: LoginForm) => {
    signIn({ ...values, email: values.email || values.phone });
  };

  const handleGoogleLogin = () => {
    console.log('Google login clicked');
  };

  const handleFacebookLogin = () => {
    console.log('Facebook login clicked');
  };

  const handleForgotPassword = () => {
    console.log('Forgot password clicked');
  };

  const handleCreateAccount = () => {
    console.log('Create account clicked');
  };

  const cardTitle = (
    <Title level={4} className="login-title">
      {t('login.bfsgWaiting')}
    </Title>
  );

  return (
    <div className="login-page">
      <Row justify="center" align="middle" className="login-row">
        <Col xs={22} sm={16} md={12} lg={10}>
          <div className="login-container">
            <img src="d.png" alt="BF Stride Group" className="login-logo" />

            <Card className="login-card" title={cardTitle}>
              <Row gutter={[24, 24]}>
                {/* Formulaire de connexion */}
                <Col xs={24} md={12}>
                  <Form<LoginForm>
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    requiredMark={false}
                    initialValues={{ remember: false }}
                  >
                    <Form.Item>
                      <Switch
                        checkedChildren={t('login.phone')}
                        unCheckedChildren={t('login.email')}
                        onChange={setUsePhone}
                        className="login-switch"
                      />
                    </Form.Item>

                    {usePhone ? (
                      <Form.Item
                        name="phone"
                        rules={[
                          { required: true, message: t('login.phoneRequired') },
                        ]}
                      >
                        <Input
                          type="tel"
                          size="large"
                          placeholder={t('login.phone')}
                          autoComplete="tel"
                          className="login-input"
                        />
                      </Form.Item>
                    ) : (
                      <Form.Item
                        name="email"
                        rules={[
                          { required: true, message: t('login.emailRequired') },
                          { type: 'email' },
                        ]}
                      >
                        <Input
                          type="email"
                          size="large"
                          placeholder={t('login.email')}
                          autoComplete="email"
                          className="login-input"
                        />
                      </Form.Item>
                    )}

                    <Form.Item
                      name="password"
                      rules={[
                        { required: true, message: t('login.passwordRequired') },
                      ]}
                    >
                      <Input.Password
                        size="large"
                        placeholder={t('login.password')}
                        autoComplete="current-password"
                        className="login-input"
                      />
                    </Form.Item>

                    <div className="login-links">
                      <Text className="forgot-password" onClick={handleForgotPassword}>
                        {t('login.forgotPassword')}
                      </Text>
                      <Text className="create-account" onClick={handleCreateAccount}>
                        {t('login.createAccount')}
                      </Text>
                    </div>

                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      block
                      className="login-button"
                    >
                      {t('login.loginButton')}
                    </Button>
                  </Form>
                </Col>

                {/* Connexion sociale */}
                <Col xs={24} md={12} className="social-login-col">
                  <Divider type="vertical" className="social-divider" />
                  <div className="social-login-container">
                    <Text className="social-login-title">Connexion rapide</Text>
                    <Button
                      size="large"
                      block
                      className="google-button"
                      icon={<GoogleOutlined />}
                      onClick={handleGoogleLogin}
                    >
                      Connexion avec Google
                    </Button>
                    <Button
                      size="large"
                      block
                      className="facebook-button"
                      icon={<FacebookOutlined />}
                      onClick={handleFacebookLogin}
                    >
                      Connexion avec Facebook
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
};